function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: { "Content-Type": "application/json", "Accept": `application/${type}` }
  };
}

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.section;
    this.productUrl = this.dataset.url;
    this.multipleProductVariants = this.querySelectorAll("[type=\"application/json\"][data-product]").length > 1;
    this.addEventListener("change", this.onVariantChange);
    this.cachedFetch = [];
  }

  onVariantChange() {
    const previousProductUrl = "" + this.productUrl;
    this.updateOptions();
    this.updateProductUrl();
    this.updateMasterId(previousProductUrl);

    this.removeErrorMessage();

    if (this.currentVariant) {
      this.updateURL();
      this.renderPage(previousProductUrl);
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll("select:not([related-variant])"), (select) => select.value);
  }

  updateMasterId(previousProductUrl) {
    const variantsData = this.getVariantData();
    if (variantsData.length == 1) {
      return this.currentVariant = variantsData[0];
    }
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
    if (!this.currentVariant && previousProductUrl != this.productUrl) {
      console.warn(`No variant found matching the options: ${this.options.join(", ")} for product ${this.productUrl}, fallback to first variant`);
      return this.currentVariant = variantsData[0];
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    // window.history.replaceState({ }, '', `${this.productUrl}?variant=${this.currentVariant.id}`); // adds variant to url
    window.history.replaceState({ }, "", `${this.productUrl}`); // keep variant in url to support back in stock
  }

  getSections() {
    return [
      {
        section: this.sectionId,
      }
    ];
  }

  renderDetails(html) {
    document.querySelector(".product-details").innerHTML = new DOMParser().parseFromString(html, "text/html").querySelector(".product-details").innerHTML;
  }

  renderProductTabs(html) {
    document.querySelectorAll("apt-tabs-content[id]").forEach((tabContent) => {
      const updatedTabContent = new DOMParser().parseFromString(html, "text/html").querySelector(`apt-tabs-content[id="${tabContent.id}"]`);
      if (updatedTabContent) {
        tabContent.innerHTML = updatedTabContent.innerHTML;
      }
    });
  }

  renderVariantInputs(html) {
    document.querySelector(".product-related-variants-input").innerHTML = new DOMParser().parseFromString(html, "text/html").querySelector(".product-related-variants-input").innerHTML;
    document.querySelector(".product-variant-inputs").innerHTML = new DOMParser().parseFromString(html, "text/html").querySelector(".product-variant-inputs").innerHTML;
  }

  renderProductForms(html) {
    const productForms = document.querySelectorAll("product-form");
    productForms.forEach((productForm) => {
      // id
      const input = productForm.querySelector("input[name=\"id\"]");
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
      // sumbit button
      const renderSubmitButtonEl = new DOMParser().parseFromString(html, "text/html").querySelector(".product-form-submit");
      const submitButton = productForm.querySelector(".product-form-submit");
      if (submitButton) {
        submitButton.replaceWith(renderSubmitButtonEl);
      }
    });
  }

  renderBackInStockForm(html) {
    const formContainerEl = document.querySelector(".back-in-stock-form--container");
    if (!formContainerEl) return;
    const renderedFormContainerEl = new DOMParser().parseFromString(html, "text/html").querySelector(".back-in-stock-form--container");
    formContainerEl.replaceWith(renderedFormContainerEl);
  }

  renderStickyAddToCart(html) {
    const stickyAddToCartEl = document.querySelector("apt-sticky-add-to-cart");
    if (!stickyAddToCartEl) return;

    const renderedStickyAddToCartEl = new DOMParser().parseFromString(html, "text/html").querySelector("apt-sticky-add-to-cart");
    stickyAddToCartEl.replaceWith(renderedStickyAddToCartEl);
  }

  renderMedia(html, previousProductUrl) {
    if (this.multipleProductVariants && this.productUrl == previousProductUrl) {
      return;
    }
    document.querySelector(".product-medias").innerHTML = new DOMParser().parseFromString(html, "text/html").querySelector(".product-medias").innerHTML;
  }

  renderDescription(html) {
    const productDescriptionEl = document.querySelector(".product-description");
    const newProductDescriptionDom = new DOMParser().parseFromString(html, "text/html").querySelector(".product-description");
    newProductDescriptionDom.querySelectorAll("details").forEach((details) => {
      if (productDescriptionEl.querySelector("#" + details.id)) {
        if (productDescriptionEl.querySelector("#" + details.id).open) {
          details.open = true;
        } else {
          details.removeAttribute("open");
        }
      }
    });
    document.querySelector(".product-description").innerHTML = newProductDescriptionDom.innerHTML;
  }

  renderSizeGuide(html) {
    const sizeGuideEl = document.querySelector(".size-guide");
    const newSizeGuideEl = new DOMParser().parseFromString(html, "text/html").querySelector(".size-guide");
    if (sizeGuideEl) {
      if (newSizeGuideEl) {
        sizeGuideEl.innerHTML = newSizeGuideEl.innerHTML;
      } else {
        sizeGuideEl.innerHTML = "";
      }
    }
  }

  renderSectionWithHtml(html, previousProductUrl) {
    this.renderDetails(html);
    this.renderVariantInputs(html);
    this.renderProductForms(html);
    this.renderStickyAddToCart(html);
    this.renderBackInStockForm(html);
    this.renderMedia(html, previousProductUrl);
    this.renderDescription(html);
    this.renderSizeGuide(html);
    this.renderProductTabs(html);
  }

  renderSectionFromFetch(url, previousProductUrl) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        this.cachedFetch = [...this.cachedFetch, { html, url }];
        this.renderSectionWithHtml(html, previousProductUrl);
      });
  }

  renderSectionFromCache(url, previousProductUrl) {
    const html = this.cachedFetch.find((element) => element.url === url).html;
    this.renderSectionWithHtml(html, previousProductUrl);
  }

  renderPage(previousProductUrl) {
    const sections = this.getSections();

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&variant=${this.currentVariant.id}`;

      this.cachedFetch.some((element) => element.url === url) ?
        this.renderSectionFromCache(url, previousProductUrl) :
        this.renderSectionFromFetch(url, previousProductUrl);
    });
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  getVariantData() {
    if (!this.variantData || !this.variantData[this.productUrl]) {
      const selector = "[type=\"application/json\"][data-product=\"" + this.productUrl + "\"]";
      const dataSource = JSON.parse(this.querySelector(selector).textContent);
      this.variantData = {
        ...this.variantData,
        [this.productUrl]: dataSource
      };
    }
    return this.variantData[this.productUrl];
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset:not([related-variant])"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find((radio) => radio.checked).value;
    });
  }

  updateProductUrl() {
    if (this.querySelectorAll("fieldset[related-variant] input").length > 0) {
      this.productUrl = Array.from(this.querySelectorAll("fieldset[related-variant] input")).find((radio) => radio.checked).value;
    }
  }
}

customElements.define("variant-radios", VariantRadios);

if (!customElements.get("product-form")) {
  customElements.define("product-form", class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector("form");
      this.form.querySelector("[name=id]").disabled = false;
      this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector("button[name=\"add\"]");


      if (submitButton.classList.contains("loading")) return;
      submitButton.setAttribute("disabled", true);

      this.handleErrorMessage();

      submitButton.setAttribute("aria-disabled", true);
      submitButton.classList.add("loading");
      const config = fetchConfig("javascript");
      config.headers["X-Requested-With"] = "XMLHttpRequest";
      delete config.headers["Content-Type"];

      const formData = new FormData(this.form);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          document.querySelector("cart-drawer")?.refresh(true);
          if (document.querySelector("cart-counter")) {
            document.querySelector("cart-counter").refresh();
          }

        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove("loading");
          submitButton.removeAttribute("aria-disabled");
          submitButton.setAttribute("disabled", false);
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper");
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message");

      this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}